import { ValidationRule, ValidationResult, Value } from '@cnamts/vue-dot/src/rules/types';
import { formatStandardStringToDate } from '@/services/dateFormatter';
import _ from 'lodash';

const defaultErrorMessages = {
	default: 'Erreur dans la date saisie.'
};

export function notBeforeDate(date: string, errorMessages = defaultErrorMessages): ValidationRule<Value> {
	return (value: Value): ValidationResult => {
		if (!value || _.isEmpty(value)) {
			return true;
		}
		return !isDateBeforeDate(value, date) || errorMessages.default;
	};
}

export function isDateBeforeDate(value: string, date: string) {
	if (_.isEmpty(date)) {
		return false;
	}
	return formatStandardStringToDate(value).isBefore(formatStandardStringToDate(date));
}
